<template>
  <div :id="id" :className="className" :style="{height:height,width:width}" />
</template>

<script>

import * as echarts from 'echarts'
import resize from '@/utils/mixins/resize'
import { formatNum } from '@/utils/util'

export default {
  mixins: [resize],
  props: {
    id: {
      type: String,
      default: 'chart'
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    goodsByHistogram: {
      type: null,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
      options: {
        backgroundColor: '#fff',
        width: '90%',
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          // formatter: function(params, ticket, callback) {
          //   let tooltip = '<div>'
          //   if (params.length > 0) {
          //     tooltip += `<p>取消订单量: ${params[2].data.current} </p><p>${params[0].marker} ${params[0].seriesName} ${params[0].data.current}, 占比 ${params[0].data.current}%</p>`
          //     if (params[1]) {
          //       tooltip += `<p>${params[1].marker} ${params[1].seriesName} ${params[1].data.current},占比 ${params[1].data.current}%</p>`
          //     }
          //   }
          //   tooltip += '</div>'
          //   return tooltip
          // },
          axisPointer: {
            type: 'shadow',
            textStyle: {
              color: '#fff'
            }
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          borderWidth: 0,
          top: 60,
          bottom: 95,
          textStyle: {}
        },
        // legend: {
        //   show: true,
        //   selectedMode: false,
        //   orient: 'horizontal',
        //   left: 'center',
        //   top: 48,
        //   itemGap: 50,
        //   itemWidth: 14,
        //   itemHeight: 14,
        //   icon: 'rect',
        //   textStyle: {
        //     color: '#90979c'
        //   },
        //   data: ['用户取消', '客服取消']
        // },
        calculable: true,
        xAxis: [{
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            interval: 0,
            rotate: 30
          },
          data: []
        }],
        yAxis: [{
          type: 'value',
          minInterval: 1,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EEEEEE'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#90979c'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0
          },
          splitArea: {
            show: false
          }
        }],
        dataZoom: [
          {
            show: true,
            height: 10,
            xAxisIndex: [
              0
            ],
            bottom: 20,
            // start: 0,
            // end: 20,
            startValue: 0,
            endValue: 16,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%',
            handleStyle: {
              color: '#d3dee5'
            },
            textStyle: {
              color: '#fff'
            },
            borderColor: '#90979c'
          },
          {
            type: 'inside',
            show: true,
            height: 15,
            start: 1,
            end: 20,
            zoomOnMouseWheel: false
          }
        ],
        series: [
          {
            name: '总数',
            type: 'bar',
            stack: '总量',
            itemStyle: {
              normal: {
                color: '#FF7800',
                barBorderRadius: 0,
                label: {
                  show: false,
                  position: 'top'
                }
              }
            },
            data: []
          }
        ]
      }
    }
  },
  watch: {
    goodsByHistogram(value) {
      this.goodsByHistogram = value
      // console.log(this.goodsByHistogram)
      this.initChart()
    }
  },
  mounted() {
    this.chart = echarts.init(document.getElementById(this.id))
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      const vm = this
      // 未获取数据前，显示loading加载动画
      if (vm.goodsByHistogram == null || vm.goodsByHistogram === '') {
        vm.chart.showLoading()
      } else {
        vm.chart.hideLoading()
        const { list: goodsByHistogram } = this.goodsByHistogram
        const options = vm.options

        const time = Object.keys(goodsByHistogram)
        const customerNum = Object.values(goodsByHistogram).map(i => {
          return {
            value: i.current,
            ...i
          }
        })
        // const UserNum = Object.values(goodsByHistogram).map(i => {
        //   return {
        //     value: i.current,
        //     ...i
        //   }
        // })
        // const TotalNum = Object.values(goodsByHistogram).map(i => {
        //   return {
        //     value: i.current,
        //     ...i
        //   }
        // })
        options.xAxis[0].data = time
        options.series[0].data = customerNum
        // options.series[1].data = UserNum
        // options.series[2].data = TotalNum
        vm.chart.setOption(options, true)
      }
    }
  }
}
</script>
